var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.995401 8.99136C1.25592 9.26948 1.67831 9.26948 1.93883 8.99136L8.00001 2.52056L14.0612 8.99135C14.3217 9.26948 14.7441 9.26948 15.0046 8.99135C15.2651 8.71323 15.2651 8.26229 15.0046 7.98417L8.47057 1.00854C8.21005 0.730418 7.78767 0.730418 7.52714 1.00854C7.51597 1.02047 7.50528 1.03272 7.49506 1.04526L0.995401 7.98417C0.73488 8.2623 0.73488 8.71323 0.995401 8.99136Z",
    fill: "#798EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.8a39cfcee8b0228577bd6d4a5810c34c.svg";
export { ForwardRef as ReactComponent };